<template>
  <div>
    <h4 :style="{ marginBottom: '20px' }">{{ title }}</h4>
    <v-chart :forceFit="true" :height="height" :data="dataSource" :scale="scale" :padding="padding">
      <v-tooltip/>
      <v-axis/>
      <v-bar position="x*y"/>
    </v-chart>
  </div>
</template>

<script>
  import { triggerWindowResizeEvent } from '@/utils/util'

  export default {
    name: 'Bar',
    props: {
      dataSource: {
        type: Array,
        required: true
      },
      yaxis: [
            {                   
                type: 'value',
                color: '#f00',
                axisLabel: {formatter: '{value} 单'},
            }
        ],

      yaxisText: {
        type: String,
        default: 'y',
        axisLabel: {//x轴文字show: true,textStyle: {
                    color: '#f00',//更改坐标轴文字颜色fontSize: 12//更改坐标轴文字大小}
            },
      },
      title: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 254
      }
    },
    data() {
      return { padding: ['auto', 'auto', '40', '50'] }
    },
    computed: {
      scale() {
        return [{
          dataKey: 'y-1',
          alias: this.yaxisText,
          yaxis: [
            {                   
                type: 'value',
                color: '#f00',
                axisLabel: {formatter: '{value} 单'},
            }
        ]
        }]
      }
    },
    mounted() {
      triggerWindowResizeEvent()
    }
  }
</script>